import * as actionTypes from './actionTypes';
import * as actions from './index';
import { getClipsForProjectSuccess, setActiveProject } from './projects';
import { setActiveRoom } from './rooms';
import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';
import Clip from 'Flow2/util/Clip';


export const getClipsForClipListStart = () => {
    return {
        type: actionTypes.GET_CLIPLIST_START
    }
}
export const getClipsForClipListFail = (error) => {
    return {
        type: actionTypes.GET_CLIPLIST_FAIL,
        error: error
    }
}
export const getClipsForClipListSuccess = (type, id, clipList) => {
    return {
        type: actionTypes.GET_CLIPLIST_SUCCESS,
        payload: { type: type, id: id, clipList: clipList }
    }
}
export const clipUpdateReceived = (clip) => {
    return {
        type: actionTypes.CLIP_UPDATE_RECEIVED,
        payload: { clip: clip }
    }
}

export const setClipList = (type, id) => {
    return {
        type: actionTypes.SET_CLIPLIST,
        payload: { type: type, id: id }
    }
}
/*export const getDeletedClipsSuccess = (clipList) => {
    console.log(clipList);
    return {
        type: actionTypes.GET_DELETED_CLIPS_SUCCESS,
        payload: {clipList: clipList}
    }
}*/

/*export const getDeletedClips = () => {
    return dispatch => {
        // dispatch(getClipsForClipListStart());
        window.flow.getClipsByFields([{'field':'type', 'type':'=', 'value':'delete'}]).then(res => {
            dispatch(actions.getDeletedClipsSuccess(res.objects.elements));
        }).catch(res => {
            dispatch(getClipsForClipListFail(res.message));
            dispatch(actions.applicationError(res.message));
        })
    }
}
*/
export const getClipsForClipList = (type, clipListId) => {
    return dispatch => {
        dispatch(getClipsForClipListStart());

        if (!type || (type !== 'project' && type !== 'room' && type !== 'distribution')) {
            dispatch(getClipsForClipListFail('No type for Cliplist specified.'));
            dispatch(actions.applicationError('No type for Cliplist specified.'));
        }

		/*
        window.flow.getProjectById(clipListId).then((clipList) => {
            dispatch(getClipsForClipListSuccess(type, clipList.id, clipList));
            dispatch(type === 'project' && setActiveProject(clipList.id) || setActiveRoom(clipList.id));
            dispatch(actions.resetTickedClips());
            dispatch(actions.resetMultiSelected());
            //dispatch(getClipsForProjectSuccess(clipList));
        }).catch((res) => {
            console.log(res);
            dispatch(getClipsForClipListFail(res.message));
            dispatch(actions.applicationError(res.message));
        });
		*/

        if (type === 'room') {
            window.flow.getShowroomById(clipListId).then((clipList) => {
                dispatch(getClipsForClipListSuccess('room', clipList.id, clipList));
                dispatch(setActiveRoom(clipList.id));
                dispatch(actions.resetTickedClips());
                dispatch(actions.resetMultiSelected());
                //dispatch(getClipsForProjectSuccess(clipList));
            }).catch((res) => {
                console.log(res);
                dispatch(getClipsForClipListFail(res.message));
                dispatch(actions.applicationError(res.message));
            });
        } else {
            window.flow.getProjectById(clipListId).then((clipList) => {
                dispatch(getClipsForClipListSuccess('project', clipList.id, clipList));
                dispatch(setActiveProject(clipList.id));
                dispatch(actions.resetTickedClips());
                dispatch(actions.resetMultiSelected());
                //dispatch(getClipsForProjectSuccess(clipList));
            }).catch((res) => {
                console.log(res);
                dispatch(getClipsForClipListFail(res.message));
                dispatch(actions.applicationError(res.message));
            });
        }



        /*switch (type) {
            case 'project':
                window.flow.getProjectById(clipListId).then((clipList) => {                  
                    dispatch(getClipsForClipListSuccess('project', clipList.id, clipList));
                    dispatch(setActiveProject(clipList.id));
                    dispatch(actions.resetTickedClips());
                    dispatch(actions.resetMultiSelected());
                    //dispatch(getClipsForProjectSuccess(clipList));
                }).catch((res) => {
                    console.log(res);
                    dispatch(getClipsForClipListFail(res.message));
                    dispatch(actions.applicationError(res.message));
                })
                break;
            case 'room':
                window.flow.getProjectById(clipListId).then((clipList) => {                  
                    dispatch(getClipsForClipListSuccess('room', clipList.id, clipList));
                    dispatch(setActiveRoom(clipList.id));
                    dispatch(actions.resetTickedClips());
                    dispatch(actions.resetMultiSelected());
                    //dispatch(getClipsForProjectSuccess(clipList));
                }).catch((res) => {
                    console.log(res);
                    dispatch(getClipsForClipListFail(res.message));
                    dispatch(actions.applicationError(res.message));
                })
                break;
            default:
                dispatch(getClipsForClipListFail('No type for Cliplist specified.'));
                dispatch(actions.applicationError('No type for Cliplist specified.'));
        }*/

    }
}
export const toggleCliplistFilter = (filter) => {
    return {
        type: actionTypes.CLIPLIST_TOGGLE_FILTER,
        payload: { filter: filter }
    };
};

export const setCliplistFilter = (filter) => {
    return {
        type: actionTypes.CLIPLIST_SET_FILTER,
        payload: filter
    }
}

export const clipListDownloadStart = (id) => {
    return {
        type: actionTypes.CLIPLIST_DOWNLOAD_START,
        payload: { id: id }
    }
}
export const clipListDownloadFail = (error, id) => {
    return {
        type: actionTypes.CLIPLIST_DOWNLOAD_FAIL,
        error: error,
        payload: { id: id }
    }
}
export const clipListDownloadSuccess = (id, file) => {
    return {
        type: actionTypes.CLIPLIST_DOWNLOAD_SUCCESS,
        payload: { id: id, downloadFile: file }
    }
}

export const resetDownload = () => {
    return {
        type: actionTypes.CLIPLIST_RESET_DOWNLOAD
    }
}

export const clipListDownload = (ids, clipListId = null) => {
    return (dispatch, getState) => {
        dispatch(clipListDownloadStart(clipListId));
        window.flow.newProcess('archivefiles', 'make zip', { parameters: { contenttype: 'idlist', contentlink: ids } }).then(res => {
            var interval = setInterval(function () {
                window.flow.getProcess(res.processid).then(p => {
                    console.log(p);
                    console.log(p.getStatus());
                    if (p.getStatus() == 'done') {
                        clearInterval(interval);
                        dispatch(clipListDownloadSuccess(clipListId, p.outputfileurl));
                    } else if (p.getStatus() == 'error') {
                        clearInterval(interval);
                        dispatch(clipListDownloadFail('error', clipListId));
                    }
                })

            }, 10000);
        }).catch((res) => {
            console.log(res);
            dispatch(clipListDownloadFail(res.message));
        });
    }
}

export const moveClipsToTrash = (clipIds, type, id) => {
    return dispatch => {
        console.log("MOVE CLIPS TO TRASH");
        dispatch({ type: actionTypes.CLIPLIST_DELETE_START });
        window.flow.editClip(clipIds, { 'type': 'delete' }).then((clip) => {
            console.log("SUCCESS");
            dispatch({ type: actionTypes.CLIPLIST_DELETE_SUCCESS });
            switch (type) {
                case Metadata.OBJECT_TYPE_PROJECT:
                case Metadata.OBJECT_TYPE_ROOM:
                case Metadata.OBJECT_TYPE_DISTRIBUTION:
                    dispatch(actions.getClipsForClipList(type, id));
                    break;
                default:
                    break;
            }
        }).catch((res) => {
			console.log(res);
            dispatch({ type: actionTypes.CLIPLIST_DELETE_SUCCESS });
            dispatch(actions.applicationError(res.message));
        });

    }
}

export const restoreClipsFromTrash = (clipIds) => {
    return dispatch => {
        dispatch({ type: actionTypes.CLIPLIST_RESTORE_START });
        window.flow.editClip(clipIds, { 'type': 'active' }).then((clip) => {
            dispatch({ type: actionTypes.CLIPLIST_RESTORE_SUCCESS });
        }).catch((res) => {
			console.log(res);
            dispatch({ type: actionTypes.CLIPLIST_RESTORE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    }
}

export const deleteClips = (ids) => {
    return dispatch => {
        dispatch({ type: actionTypes.CLIPLIST_DELETE_START });
        console.log("DELETE CLIPS");
        window.flow.delClip(ids).then((clip) => {
            console.log("SUCCESS");
            dispatch({ type: actionTypes.CLIPLIST_DELETE_SUCCESS });
        }).catch((res) => {
			console.log(res);
            dispatch({ type: actionTypes.CLIPLIST_DELETE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    }
}

export const getClipById = (id) => {
    return (dispatch, getState) => {
        dispatch({ type: actionTypes.GET_CLIPLIST_START });
        //window.flow.getClipsByFields([{ field: 'id', type: 'IDLIST', value: id }]).then((res) => {
		window.flow.getClipById(id).then((res) => {
            //dispatch({ type: actionTypes.GET_CLIPLIST_BY_ID_SUCCESS, payload: { clipList: res } });
			dispatch({ type: actionTypes.GET_CLIP_BY_ID_SUCCESS, clip: res, id: id });

            // refresh current clip with new data
            if (getState().clip.currentClip.id && getState().clip.currentClip.id == id) {
                dispatch(actions.selectClip(Clip.parseClip(res), getState().clipList.playerDerivatives));
            }
        }).catch((res) => {
			console.log(res);
            dispatch({ type: actionTypes.GET_CLIPLIST_FAIL, error: res.message });
            dispatch(actions.applicationError(res.message));
        });
    }
}

export const getCliplistByIds = (ids) => {
	let idList = ids;
	
	// create ',' separated string of ids 
	if(Array.isArray(idList)) {
		idList = idList.join(',');
	}
	
    return (dispatch, getState) => {
		dispatch({ type: actionTypes.GET_CLIPLIST_START });
        window.flow.getClipsByFields([{ field: 'id', type: 'IDLIST', value: idList }]).then((res) => {
			console.log(res);
			const id = getState().clip.currentClip.id;
			console.log(id, res.clip.elements[id]);
			if (id && res.clip.elements[id]) { 
				console.log("CURRENT UPDATE");
                dispatch(actions.selectClip(Clip.parseClip(res.clip.elements[id]), getState().clipList.playerDerivatives));
            }
            dispatch({ type: actionTypes.GET_CLIPLIST_BY_ID_SUCCESS, payload: { clipList: res } });
        }).catch((res) => {
			console.log(res);
            dispatch({ type: actionTypes.GET_CLIPLIST_FAIL, error: res.message });
            dispatch(actions.applicationError(res.message));
        });
    }
}

export const getRelatedClipList = (ids) => {
    return dispatch => {
        dispatch({ type: actionTypes.GET_CLIPLIST_START });
        window.flow.getClipsByFields([{ field: 'id', type: 'IDLIST', value: ids }]).then((res) => {
            dispatch({ type: actionTypes.GET_CLIPLIST_BY_ID_SUCCESS, payload: { clipList: res } });
        }).catch((res) => {
			console.log(res);
            dispatch({ type: actionTypes.GET_CLIPLIST_FAIL, error: res.message });
            dispatch(actions.applicationError(res.message));
        });
    }
}

export const arrangeClipList = (clipIds, refClipId, pos) => {
    return dispatch => {
        dispatch({ type: actionTypes.ARRANGE_CLIPLIST_START });
        dispatch({ type: actionTypes.ARRANGE_CLIPLIST_AND_END, payload: { clipIds: clipIds, refClipId: refClipId, pos: pos } });
    }
}

export const saveArrangedClipList = () => {
    return (dispatch, getState) => {
        const clipListId = getState().clipList.activeClipListId;
        const clipLists = getState().clipList.clipLists;
        if (clipListId) {
            dispatch({ type: actionTypes.SAVE_ARRANGED_CLIPLIST_START });
            window.flow.projectOrder(clipListId, clipLists[clipListId].clips).then((res) => {
                dispatch({ type: actionTypes.SAVE_ARRANGED_CLIPLIST_SUCCESS });
            }).catch((res) => {
                console.log(res);
                dispatch({ type: actionTypes.SAVE_ARRANGED_CLIPLIST_FAIL, error: res.message });
                dispatch(actions.applicationError(res.message));
            });
        }
    }
}

export const checkTranscoding = (start = true) => {
    return (dispatch) => {
        if (start) {
            let interval = setInterval(function () {
                fetch(window.location.origin + '/processstatus.json')
                    .then(response => response.json())
                    .then((jsonData) => {
                        // jsonData is parsed json object received from url
                        dispatch({ type: actionTypes.CHECK_TRANSCODING_SUCCESS, transcoding: jsonData });
                    })
                    .catch((error) => {
                        console.log("JSON ERROR");
                        dispatch({ type: actionTypes.CHECK_TRANSCODING_END });
                    });
            }, 10000);

            dispatch({ type: actionTypes.CHECK_TRANSCODING_START, transcodingChecker: interval });
        } else {
            dispatch({ type: actionTypes.CHECK_TRANSCODING_END });
        }
    }
}
